import { render } from "./CompanyHealth.vue?vue&type=template&id=3561dfb6&scoped=true&ts=true"
import script from "./CompanyHealth.vue?vue&type=script&lang=ts"
export * from "./CompanyHealth.vue?vue&type=script&lang=ts"

import "./CompanyHealth.vue?vue&type=style&index=0&id=3561dfb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3561dfb6"]])

export default __exports__